import { useLayoutEffect, useState } from "react";

export interface ElementDimensions {
  height: number;
  width: number;
}

/**
 * Observes the rendered dimensions of an element, in pixels.
 *
 * Returns `undefined` until the element has been measured.
 */
export function useElementDimensions(element: HTMLElement | null) {
  const [dimensions, setDimensions] = useState<ElementDimensions>();

  useLayoutEffect(() => {
    if (element === null) {
      return;
    }

    const observer = new ResizeObserver(() => {
      const { height, width } = element.getBoundingClientRect();

      setDimensions((previous) =>
        previous?.height === height && previous.width === width
          ? previous
          : { height, width },
      );
    });

    observer.observe(element);

    return () => {
      observer.disconnect();
    };
  }, [element]);

  return dimensions;
}
